import { G300 } from '@atlaskit/theme/colors';
import React from 'react';
import AbbreviatedNumberTooltip from "../Common/AbbreviatedNumberTooltip";
import { calculateRate, getElements } from "../PartnerReports.utils";
export const calculateTotalCount = elements => elements.reduce((total, current) => current.count + total, 0);
export const getCloudConversionsTableData = cloudConversionsAPIResponse => cloudConversionsAPIResponse.addons.map(response => {
  const evaluationsElements = getElements(response.series, 'Evaluations');
  const conversionsElements = getElements(response.series, 'Conversions');
  const evaluations = calculateTotalCount(evaluationsElements);
  const conversions = calculateTotalCount(conversionsElements);
  return {
    appKey: response.addonKey,
    appName: response.name,
    conversions,
    evaluations,
    conversationRate: calculateRate(evaluations, conversions)
  };
});
export const lineChartDetails = [{
  color: G300,
  dataKey: 'conversionRate',
  legend: 'Conversion rate'
}];
export const getChartData = totalSeries => {
  const lineChartData = [];
  const evaluationsElements = getElements(totalSeries, 'Evaluations');
  const conversionsElements = getElements(totalSeries, 'Conversions');
  evaluationsElements.forEach((element, index) => {
    lineChartData.push({
      xLabel: element.date,
      evaluation: element.count,
      conversion: conversionsElements[index].count,
      conversionRate: calculateRate(element.count, conversionsElements[index].count)
    });
  });
  return lineChartData;
};

const getValueFromPayload = (item, key) => {
  const value = item.payload[key];
  return typeof value === 'number' ? value : 0;
};

export const getChartTooltipPairs = payload => payload.map(item => {
  const rate = getValueFromPayload(item, 'conversionRate');
  const conversion = getValueFromPayload(item, 'conversion');
  const evaluation = getValueFromPayload(item, 'evaluation');
  return {
    color: item.color,
    label: item.name,
    value: "".concat(rate, "% (").concat(conversion, " / ").concat(evaluation, ")")
  };
});
export const getColumns = series => {
  const evaluationsElements = getElements(series, 'Evaluations');
  const conversionsElements = getElements(series, 'Conversions');
  const totalEvaluations = calculateTotalCount(evaluationsElements);
  const totalConversions = calculateTotalCount(conversionsElements);
  const conversionRate = calculateRate(totalEvaluations, totalConversions);
  return [{
    key: 'Evaluations',
    content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
      value: totalEvaluations
    })
  }, {
    key: 'Conversions',
    content: /*#__PURE__*/React.createElement(AbbreviatedNumberTooltip, {
      value: totalConversions
    })
  }, {
    key: 'Conversion rate',
    content: "".concat(conversionRate, "%")
  }];
};
export const getReportColumnsForSeries = series => {
  return getColumns(series);
};